// Common alert styles
export const INFO_ALERT_STYLES = {
    '& .MuiAlert-message': {
        width: '100%',
        padding: '4px 0px'
    }
};
